export default __webpack_public_path__ + "static/media/upload-cloud.00e6caf6.svg";